import { Navigate, useOutlet } from "react-router-dom";
import { useAuth } from "../../middleware/auth.middleware";

export const AuthLayout = () => {
  const { token } = useAuth();
  const outlet = useOutlet();

  if (token) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
        <div class="h-screen flex flex-col justify-between bg-gray-100">
          <div class="flex justify-center items-center h-full">
            <div class="hidden md:block w-full h-full">
              <img
                src="/assets/authImg.png"
                class="w-full h-full object-cover"
                alt="Environnement"
              />
            </div>
            <div className="flex justify-center items-center bg-gray-100">
              <div className="m-10">
                {outlet}
              </div>
            </div>

          </div>
          <div className="w-full bg-primary h-[50px] flex items-center justify-center">
          <h1 className="text-center text-white ">
            &copy; 2022 - ARPT - Developed with &hearts; By{" "}
            <a
              className="text-orange-500"
              href="https://www.easylinkgn.com"
              target="_blank"
              rel="noreferrer"
            >
              EASY LINK GUINEA
            </a>
          </h1>
        </div>
        </div>
    </>
  )

  // return (
  //   <>
  //     <div className="h-screen flex">
  //       <div className="flex-1 flex flex-col justify-center py-10 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
  //         {outlet}
  //       </div>
  //       <div className="hidden lg:block relative w-0 flex-1 bg-gray-200">
  //         <img
  //           className="absolute inset-0 h-full w-full object-cover"
  //           src="https://images.unsplash.com/photo-1546069901-ba9599a7e63c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Zm9vZHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60"
  //           alt=""
  //         />
  //       </div>
  //     </div>

  //     <footer className="bg-white">
  //         <div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 md:flex md:items-center md:justify-between lg:px-8">
  //           <div className="mt-8 md:order-1 md:mt-0 text-center">
  //             <p className="text-center text-base text-gray-400">&copy; 2022 Easy Link tout droits reservés.</p>
  //           </div>
  //         </div>
  //       </footer>
  //   </>
  // )
}
